/**
 * Keeps the items that contain every word of the query in one of the fields
 * `getFields` returns, ignoring case, so "publish survey" finds "Publish a
 * survey". An empty query keeps everything.
 */
export const searchItems = (items, query, getFields) => {
   const words = query
      .trim()
      .toLowerCase()
      .split(/\s+/)
      .filter(Boolean);
   if (!words.length) return items;
   return items.filter((item) => {
      const text = getFields(item)
         .filter(Boolean)
         .join(" ")
         .toLowerCase();
      return words.every((word) => text.includes(word));
   });
};

/**
 * Orders search results so items with more of the query's words in their
 * first field (the title) come first, then the second (summary or
 * description). Ties keep their order.
 */
export const sortByRelevance = (items, query, getFields) => {
   const words = query
      .trim()
      .toLowerCase()
      .split(/\s+/)
      .filter(Boolean);
   const hits = (field) => words.filter((word) => field?.toLowerCase().includes(word)).length;
   const score = (item) => {
      const [first, second] = getFields(item);
      return hits(first) * 10 + hits(second);
   };
   return items
      .map((item, index) => ({ item, index, score: score(item) }))
      .sort((a, b) => b.score - a.score || a.index - b.index)
      .map((entry) => entry.item);
};

/**
 * Groups by `category` in the order the categories first appear. Items
 * without one share a group with an empty name.
 */
export const groupByCategory = (items) =>
   items.reduce((groups, item) => {
      const category = item.category?.trim() || "";
      const group = groups.find((entry) => entry.category === category);
      if (group) group.items.push(item);
      else groups.push({ category, items: [item] });
      return groups;
   }, []);
